// extracted by mini-css-extract-plugin
export default {"mainView":"holiday-leave_mainView__6Lai7","title":"holiday-leave_title__UEHZh"};